// extracted by mini-css-extract-plugin
module.exports = {"type":"JV7TYSFJtGl7kXoKya2fo","active":"_2gwVgp3oS8n84FOxAwgM5A","icon":"_3VLfdYqpAixEEBcGLXNZse"};